(function () {
  "use strict";

  /* Varias secciones incluyen esta misma etiqueta <script>, así que este
     archivo puede llegar a aparecer varias veces en la misma página. Sin
     este guardián, cada copia volvería a registrar sus propios listeners
     (por ejemplo en el acordeón de preguntas frecuentes) y se pisarían
     entre sí, dejando el clic sin efecto visible la mitad de las veces. */
  if (window.__bmScriptsCargado) return;
  window.__bmScriptsCargado = true;

  function initReveals() {
    var els = document.querySelectorAll(".bm-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("bm-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("bm-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initMarquee() {
    document.querySelectorAll("[data-bm-marquee-track]").forEach(function (track) {
      if (track.dataset.bmDuplicated) return;
      var clone = track.innerHTML;
      track.innerHTML += clone;
      track.dataset.bmDuplicated = "true";
    });
  }

  function initFaq() {
    document.querySelectorAll("[data-bm-faq]").forEach(function (wrap) {
      wrap.querySelectorAll(".bm-faq-item").forEach(function (item) {
        var btn = item.querySelector(".bm-faq-pregunta");
        var panel = item.querySelector(".bm-faq-respuesta");
        if (!btn || !panel) return;
        btn.addEventListener("click", function () {
          var abierto = item.classList.contains("bm-abierto");
          wrap.querySelectorAll(".bm-faq-item.bm-abierto").forEach(function (otro) {
            if (otro !== item) {
              otro.classList.remove("bm-abierto");
              otro.querySelector(".bm-faq-pregunta").setAttribute("aria-expanded", "false");
            }
          });
          item.classList.toggle("bm-abierto", !abierto);
          btn.setAttribute("aria-expanded", String(!abierto));
        });
      });
    });
  }

  function initColorSelector() {
    document.querySelectorAll("[data-bm-color-selector]").forEach(function (wrap) {
      var swatches = wrap.querySelectorAll("[data-bm-color-swatch]");
      var precio = wrap.querySelector("[data-bm-color-precio]");
      var compareEl = wrap.querySelector("[data-bm-color-compare]");
      swatches.forEach(function (sw) {
        sw.addEventListener("click", function () {
          swatches.forEach(function (s) { s.classList.remove("bm-activo"); });
          sw.classList.add("bm-activo");
          if (precio && sw.dataset.precio) precio.textContent = sw.dataset.precio;
          if (compareEl) {
            if (sw.dataset.compare) {
              compareEl.textContent = sw.dataset.compare;
              compareEl.style.display = "";
            } else {
              compareEl.style.display = "none";
            }
          }
        });
      });
    });
  }

  function initCifras() {
    var els = document.querySelectorAll("[data-bm-cifra]");
    if (!els.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var fin = parseFloat(el.dataset.bmCifra);
        var dur = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / dur, 1);
          var val = fin * (1 - Math.pow(1 - progreso, 3));
          el.textContent = (fin % 1 === 0 ? Math.round(val) : val.toFixed(1)).toString();
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toString();
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHeroSpin() {
    var els = document.querySelectorAll("[data-bm-hero-spin]");
    if (!els.length) return;
    els.forEach(function (spin) {
      var frames = spin.querySelectorAll(".bm-hero-spin-frame");
      if (frames.length < 2) return;
      var indice = 0;
      setInterval(function () {
        frames[indice].classList.remove("bm-activo");
        indice = (indice + 1) % frames.length;
        frames[indice].classList.add("bm-activo");
      }, 900);
    });
  }

  function initTilt() {
    var els = document.querySelectorAll("[data-bm-tilt]");
    if (!els.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    els.forEach(function (wrap) {
      var card = wrap.querySelector(".bm-hero-3d-card");
      if (!card) return;
      wrap.addEventListener("pointerenter", function () {
        card.classList.add("bm-tilt-activo");
      });
      wrap.addEventListener("pointermove", function (e) {
        var rect = wrap.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var rotY = (px - 0.5) * 24;
        var rotX = (0.5 - py) * 18;
        card.style.setProperty("--bm-tilt-x", rotX.toFixed(2) + "deg");
        card.style.setProperty("--bm-tilt-y", rotY.toFixed(2) + "deg");
      });
      wrap.addEventListener("pointerleave", function () {
        card.classList.remove("bm-tilt-activo");
        card.style.setProperty("--bm-tilt-x", "6deg");
        card.style.setProperty("--bm-tilt-y", "-10deg");
      });
    });
  }

  function initGaleriaProducto() {
    document.querySelectorAll("[data-bm-prod-carrusel]").forEach(function (carrusel) {
      var visor = carrusel.closest(".bm-prod-visor");
      var galeria = carrusel.closest(".bm-prod-galeria");
      var slides = Array.prototype.slice.call(carrusel.querySelectorAll("[data-bm-slide]"));
      var dots = galeria ? Array.prototype.slice.call(galeria.querySelectorAll("[data-bm-dot-index]")) : [];
      var thumbs = galeria ? Array.prototype.slice.call(galeria.querySelectorAll("[data-bm-thumb-index]")) : [];
      var contador = visor ? visor.querySelector("[data-bm-prod-contador-actual]") : null;
      if (!slides.length) return;

      function marcarActivo(indice) {
        dots.forEach(function (d, i) { d.classList.toggle("bm-activo", i === indice); });
        thumbs.forEach(function (t, i) { t.classList.toggle("bm-activo", i === indice); });
        if (contador) contador.textContent = String(indice + 1);
        var thumbActivo = thumbs[indice];
        if (thumbActivo && thumbActivo.scrollIntoView) {
          thumbActivo.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
        }
      }

      function irA(indice, suave) {
        var slide = slides[indice];
        if (!slide) return;
        carrusel.scrollTo({ left: slide.offsetLeft, behavior: suave === false ? "auto" : "smooth" });
        marcarActivo(indice);
      }

      dots.forEach(function (dot) {
        dot.addEventListener("click", function () { irA(parseInt(dot.dataset.bmDotIndex, 10)); });
      });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () { irA(parseInt(thumb.dataset.bmThumbIndex, 10)); });
      });

      var ticking = false;
      carrusel.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var idx = Math.round(carrusel.scrollLeft / (carrusel.clientWidth || 1));
          idx = Math.max(0, Math.min(slides.length - 1, idx));
          marcarActivo(idx);
          ticking = false;
        });
      }, { passive: true });

      slides.forEach(function (slide, indice) {
        slide.dataset.bmIndice = indice;
      });
    });

    window.bmIrASlideProducto = function (sectionId, slideEl) {
      if (!slideEl) return;
      var carrusel = slideEl.closest("[data-bm-prod-carrusel]");
      var galeria = slideEl.closest(".bm-prod-galeria");
      if (!carrusel) return;
      var slides = Array.prototype.slice.call(carrusel.querySelectorAll("[data-bm-slide]"));
      var indice = slides.indexOf(slideEl);
      if (indice < 0) return;
      carrusel.scrollTo({ left: slideEl.offsetLeft, behavior: "smooth" });
      if (galeria) {
        galeria.querySelectorAll("[data-bm-dot-index]").forEach(function (d, i) { d.classList.toggle("bm-activo", i === indice); });
        galeria.querySelectorAll("[data-bm-thumb-index]").forEach(function (t, i) { t.classList.toggle("bm-activo", i === indice); });
      }
      var contador = carrusel.closest(".bm-prod-visor");
      contador = contador ? contador.querySelector("[data-bm-prod-contador-actual]") : null;
      if (contador) contador.textContent = String(indice + 1);
    };
  }

  function initCuentaAtras() {
    var els = document.querySelectorAll("[data-bm-cuenta-atras]");
    if (!els.length) return;

    function actualizar() {
      els.forEach(function (el) {
        var duracion = parseInt(el.dataset.bmCuentaDuracion, 10) || 3600;
        var segundosDesde = Math.floor(Date.now() / 1000) % duracion;
        var restante = duracion - segundosDesde;
        var horas = Math.floor(restante / 3600);
        var min = Math.floor((restante % 3600) / 60);
        var seg = restante % 60;
        var elHoras = el.querySelector("[data-bm-cuenta-horas]");
        var elMin = el.querySelector("[data-bm-cuenta-min]");
        var elSeg = el.querySelector("[data-bm-cuenta-seg]");
        if (elHoras) elHoras.textContent = String(horas).padStart(2, "0");
        if (elMin) elMin.textContent = String(min).padStart(2, "0");
        if (elSeg) elSeg.textContent = String(seg).padStart(2, "0");
      });
    }

    actualizar();
    setInterval(actualizar, 1000);
  }

  function initComparador() {
    document.querySelectorAll("[data-bm-comparador]").forEach(function (outer) {
      var wrap = outer.querySelector("[data-bm-comp-wrap]");
      var imgAntes = outer.querySelector('[data-bm-comp-img="antes"]');
      if (!wrap || !imgAntes) return;

      function fijarPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        outer.style.setProperty("--bm-comp-pos", pct + "%");
      }

      function posDesdeEvento(e) {
        var rect = outer.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        return (x / rect.width) * 100;
      }

      var arrastrando = false;
      outer.addEventListener("pointerdown", function (e) {
        arrastrando = true;
        outer.setPointerCapture(e.pointerId);
        fijarPos(posDesdeEvento(e));
      });
      outer.addEventListener("pointermove", function (e) {
        if (!arrastrando) return;
        fijarPos(posDesdeEvento(e));
      });
      ["pointerup", "pointercancel", "pointerleave"].forEach(function (ev) {
        outer.addEventListener(ev, function () { arrastrando = false; });
      });
    });
  }

  function initParallax() {
    var els = document.querySelectorAll("[data-bm-parallax]");
    if (!els.length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var ticking = false;
    function actualizar() {
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var progreso = (rect.top + rect.height / 2 - vh / 2) / vh;
        var intensidad = parseFloat(el.dataset.bmParallax) || 18;
        el.style.transform = "translateY(" + (progreso * intensidad).toFixed(2) + "px)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(actualizar); ticking = true; }
    }, { passive: true });
    actualizar();
  }

  function initLightbox() {
    var triggers = document.querySelectorAll("[data-bm-zoom]");
    if (!triggers.length) return;
    var overlay, imgEl;

    function construir() {
      overlay = document.createElement("div");
      overlay.className = "bm-lightbox";
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.innerHTML =
        '<button type="button" class="bm-lightbox-cerrar" aria-label="Cerrar">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>' +
        "</button>" +
        '<img class="bm-lightbox-img" src="" alt="">';
      document.body.appendChild(overlay);
      imgEl = overlay.querySelector(".bm-lightbox-img");
      overlay.querySelector(".bm-lightbox-cerrar").addEventListener("click", cerrar);
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) cerrar();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && overlay.classList.contains("bm-activo")) cerrar();
      });
    }

    function abrir(src, alt) {
      if (!overlay) construir();
      imgEl.src = src;
      imgEl.alt = alt || "";
      overlay.classList.add("bm-activo");
      document.body.classList.add("bm-lightbox-abierto");
    }

    function cerrar() {
      if (!overlay) return;
      overlay.classList.remove("bm-activo");
      document.body.classList.remove("bm-lightbox-abierto");
    }

    triggers.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        abrir(el.dataset.zoomSrc, el.dataset.zoomAlt);
      });
    });
  }

  function initArrastreHorizontal() {
    document.querySelectorAll("[data-bm-res-carrusel]").forEach(function (track) {
      var wrap = track.parentElement;
      if (!wrap) return;
      var arrastrando = false;
      var moved = false;
      var startX = 0;
      var startScroll = 0;

      wrap.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "touch") return;
        arrastrando = true;
        moved = false;
        startX = e.clientX;
        startScroll = wrap.scrollLeft;
        wrap.classList.add("bm-arrastrando");
        wrap.setPointerCapture(e.pointerId);
      });
      wrap.addEventListener("pointermove", function (e) {
        if (!arrastrando) return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 4) moved = true;
        wrap.scrollLeft = startScroll - delta;
      });
      function soltar() {
        arrastrando = false;
        wrap.classList.remove("bm-arrastrando");
      }
      wrap.addEventListener("pointerup", soltar);
      wrap.addEventListener("pointerleave", soltar);
      wrap.addEventListener("click", function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveals();
    initMarquee();
    initFaq();
    initColorSelector();
    initCifras();
    initParallax();
    initTilt();
    initHeroSpin();
    initComparador();
    initArrastreHorizontal();
    initCuentaAtras();
    initGaleriaProducto();
    initLightbox();
  });
})();
